module.exports = __webpack_public_path__ + "mainassets/img/form-error-times.f152e48a.svg";